import { variant } from 'styled-system';

const typeVariant = () =>
  variant({
    prop: 'type',
    variants: {
      block: {
        bg: 'drawerHeader.bg',
        color: 'drawerHeader.color',
        width: '100%',
        minHeight: 'drawerHeader.minHeight',
        borderBottom: 'drawerHeader',
        boxShadow: '0',
      },
      transparent: {},
    },
  });

export default typeVariant;
